import React from "react";
import HeroCarousel from "./HeroCarousel";
import { CTA02, DynamicNavigation, FeatureSection, Footer, HomeMigrationServicesSection, MeetOurTeam, ProcessSection } from "./components";
import { useNavLinkClick } from "./hooks/useNavLinkClick";
import { useSeo } from "./seo";

const links = [
  { id: "home", label: "Home", href: "/" },
  { id: "services", label: "Services", href: "/services" },
  { id: "about", label: "About", href: "/about" },
  { id: "contact", label: "Contact", href: "/contact" },
];

export default function HomePage() {
  const onLinkClick = useNavLinkClick(links);

  useSeo({
    title: "Hola World Migration Australia | PR & Skilled Visa Experts",
    description:
      "Hola World Migration Australia provides expert guidance for PR, skilled visas, and migration pathways. Trusted migration consultants helping students and professionals settle in Australia.",
    path: "/",
    image: "/assets/home-hero/hero-banner-01.jpg",
    breadcrumbs: [{ name: "Home", url: "/" }],
  });

  return (
    <div className="min-h-screen bg-slate-100 overflow-x-hidden">
      <header className="w-full">
        <DynamicNavigation
          links={links}
          logo={<img src="/logo.png" alt="Logo" className="h-10 w-auto" />}
          showLabelsOnMobile={true}
          glowIntensity={6}
          onLinkClick={onLinkClick}
        />
      </header>
      <HeroCarousel />
      <FeatureSection />
      <HomeMigrationServicesSection />
      <ProcessSection />
      <MeetOurTeam />
      <CTA02 />
      <Footer />
    </div>
  );
}
